import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    CategorieDArticleJsonldCategorieArticleAll,
    CategorieDArticleApi,
} from '../../../openApi/ApiOffre';
import { ARTICLES_CATEGORIES_SLICE_NAME, OFFRE_REDUCER_NAME } from '../constants';

export type ArticleCategoryApiObject = CategorieDArticleJsonldCategorieArticleAll &
    Record<string, unknown>;

export type ArticlesCategories = ArticleCategoryApiObject;

const mapperArticlesCategories = function (articles: ArticleCategoryApiObject) {
    return {
        ...articles,
    } as ArticlesCategories;
};

export function createArticlesCategoriesSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new CategorieDArticleApi(conf);

    const fetchArticlesCategoriesCollection: FetchCollectionData<ArticleCategoryApiObject> = ({
        pagination: { page },
        filters,
    }) => {
        let domaineId: number | undefined;

        if (filters?.domaineId) {
            domaineId = filters.domaineId as number;
        }

        return api
            .apiCategoriesArticlesGetCollection({
                page: page + 1,
                itemsPerPage: 1000,
                domaineId,
            })
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<ArticleCategoryApiObject>>;
    };

    const fetchArticlesCategoriesItem: FetchItemDataType<ArticleCategoryApiObject> = ({ idItem }) =>
        api
            .apiCategoriesArticlesIdGet({
                id: String(idItem),
            })
            .then((res) => res.data) as Promise<ArticleCategoryApiObject>;

    const {
        slice: articlesCategoriesSlice,
        dataSourcesThunks: articlesCategoriesDataSourcesThunks,
    } = SliceFactory.createSlice<ArticleCategoryApiObject, ArticlesCategories>(
        ARTICLES_CATEGORIES_SLICE_NAME,
        OFFRE_REDUCER_NAME,
        [],
        fetchArticlesCategoriesCollection,
        fetchArticlesCategoriesItem,
        mapperArticlesCategories,
    );

    return { articlesCategoriesSlice, articlesCategoriesDataSourcesThunks };
}
